<template>
<div :class="`ee-select ee-select--${size}`" @mouseLeav="showList = false" :style="`width: ${width}px`">
  <div @click="showList = !showList" class="ee-select__toggle">
    <span class="ee-select__placeholder" v-if="!value && !current">{{placeholder}}</span>
    {{current}}<i :class="`text-icon ${showList ? 'active' : ''}`"></i>
  </div>
  <ul v-show="showList" class="ee-select__content">
    <li :class="{active: item.value == value || item == value}" @click="handleChange(item)" v-for="item in dataSource">{{item.text || item}}</li>
  </ul>
</div>
</template>
<script>
  export default {
    compName: 'ee-select',
    props: {
      width: {
        type: Number,
        default: 200
      },
      size: {
        type: String,
        default: 'default'
      },
      dataSource: {
        type: Array,
        required: true,
        default: []
      },
      placeholder: String,
      value: {
        type: [Number, String],
        default: ''
      }
    },
    methods: {
      handleChange (item) {
        if (typeof item === 'object') {
          this.$emit('input', item.value)
        } else {
          this.$emit('input', item)
        }
        this.showList = false
      }
    },
    data () {
      return {
        showList: false
      }
    },
    computed: {
      current () {
        let current = ''
        this.dataSource.every(item => {
          if (item.value === this.value) {
            current = item.text
            return false
          }
          if (item === this.value) {
            current = item
            return false
          }
          return true
        })
        return current
      }
    }
  }
</script>
<style>
@import "../style/vars.css";
@component-namespace ee {
  @b select {
    position: absolute;
    line-height: 1;
    @e toggle {
      @utils-ellipsis;
      position: relative;
      padding: 0 20px 0 5px;
      border: 1px solid var(--border-color);
      background-color: #fff;
      cursor: pointer;
      .text-icon {
        position: absolute;
        top: 50%;
        right: 6px;
        width: 10px;
        height: 12px;
        margin-top: 2px;
        border-style: solid;
        border-width: 8px 5px 3px;
        transform: translateY(-50%);
        transition: all .3s;
        border-color: #28a7e1 transparent transparent;
        &.active {
          transform-origin: 5px 3px;
          transform: translateY(-50%) rotate(180deg);
        }
      }
    }
    @e placeholder {
      opacity: .75;
    }
    @e content {
      position: absolute;
      top: 100%;
      width: 100%;
      padding: 5px 0;
      border: 1px solid #eee;
      z-index: 99;
      background-color: #fff;
      box-shadow: 0 2px 10px 1px rgba(0, 0, 0, .1);
      li {
        padding-left: 5px;
        border: 1px solid transparent;
        cursor: pointer;
        &:hover, &.active {
          background-color: rgba(0, 0, 0, .1);
        }
      }
    }
    @m xlarge {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 54px;
        padding: 15px 20px;
        font-size: 22px;
      }
    }
    @m large {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 48px;
        padding: 14px 20px;
        font-size: 18px;
      }
    }
    @m middle {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 42px;
        padding: 12px 20px;
        font-size: 16px;
      }
    }
    @m default {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 36px;
        padding: 11px 20px;
        font-size: 14px;
      }
    }
    @m small {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 30px;
        padding: 7px 15px;
        font-size: 14px;
      }
    }
    @m tiny {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 24px;
        padding: 5px 15px;
        font-size: 12px;
      }
    }
    @m mini {
      .ee-select__toggle ,
      .ee-select__content li {
        height: 18px;
        padding: 2px 15px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/select/Select.vue?ff062bb4